import { z } from '../zod.js';

export const CHARGE_STATUS = Object.freeze({
  created: 'created',
  pending: 'pending',
  unpaid: 'unpaid',
  partially_paid: 'partially_paid',
  paid: 'paid',
  canceled: 'canceled',
  failed: 'failed',
  partial_refund: 'partial_refund',
  refunded: 'refunded',
  draft: 'draft',
  draft_expired: 'draft_expired',
} as const);

export const ChargeStatusValidationEnum = z.enum(CHARGE_STATUS);

export const ORDER_STATUS = Object.freeze({
  active: 'active',
  canceled: 'canceled',
} as const);

export const OrderStatusValidationEnum = z.enum(ORDER_STATUS);

const CHARGE_PAYMENT_OPTION_TYPE = Object.freeze({
  manual: 'manual',
  partial: 'partial',
  full: 'full',
});

export const ChargePaymentOptionTypeValidationEnum = z.enum(CHARGE_PAYMENT_OPTION_TYPE);

const CHARGE_PAYMENT_OPTION_MANUAL_TYPE = Object.freeze({
  invoice: 'invoice',
  cash_on_delivery: 'cash_on_delivery',
});

export const ChargePaymentOptionManualTypeValidationEnum = z.enum(
  CHARGE_PAYMENT_OPTION_MANUAL_TYPE,
);

const ABANDONMENT_EMAIL_STATUSES = Object.freeze({
  pending: 'pending',
  firstSent: 'first_sent',
  secondSent: 'second_sent',
  thirdSent: 'third_sent',
  // Not yet a valid value.
  // converted: 'converted',
  skipped: 'skipped',
});

export const ChargeAbandonmentEmailStatusValidationEnum = z.enum(ABANDONMENT_EMAIL_STATUSES);

const ABANDONMENT_STATUSES = Object.freeze(['abandoned', 'recovered']);
export const ChargeAbandonmentStatusValidationEnum = z.enum(ABANDONMENT_STATUSES);

export const CHARGE_ORDER_STATUS = Object.freeze(['active', 'canceled']);
export const ChargeOrderStatusValidationEnum = z.enum(CHARGE_ORDER_STATUS);
